// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"243ece36","106":"bc0d0e2f","295":"de91faff","477":"8d617d8d","488":"75a1cf24","578":"0dc4ca4e","796":"dd380d34","825":"8794371b"}[chunkId] + ".chunk.js";
};